module.exports = __webpack_public_path__ + "static/media/Mawile_gaussian2.250cb21b.png";